<div class="p-24:v md:p-32:v lg:p-48:v">
    <app-info-box headline="Unser Gerätedaten-Erfassungsservice:">
        <p class="m-0:b">
            Du möchtest eine größere Anzahl weiterer Geräte versichern, ohne diese per Hand eingeben zu müssen? Rufe uns
            an unter
            <strong>0621&nbsp;1247682-0</strong>
            oder schicke uns eine Nachricht an
            <a href="mailto:geschaeftskunden@astra-versicherung.de">geschaeftskunden&#64;astra-versicherung.de</a>.
        </p>
    </app-info-box>
</div>
